<template>
	<div
		class="w-80 h-24 flex my-4 p-4 text-center items-center rounded-lg shadow-lg bg-[#FAFAFA]"
	>
		<span v-html="renderedFact" />
	</div>
</template>

<script setup lang="ts">
import { toRefs, computed } from 'vue'

const props = defineProps({
	fact: {
		type: Object,
		required: true
	}
})

const { fact } = toRefs(props)

const renderedFact = computed(() => {
	return renderRichText(fact.value)
})
</script>
